import DeleteButton from "./delete-button";

interface Properties {
  name: string;
  value?: string;
  onChange?: (e: any) => void;
  onDelete?: () => void;
}

const InputField: React.FC<Properties> = ({ onDelete, ...props }) => {
  return (
    <div className="relative">
      <DeleteButton onDelete={onDelete} />
      <input
        className="rounded-lg shadow-md w-full border-black border-opacity-50 border-solid border p-1 px-4 h-14 font-bold"
        {...props}
      />
    </div>
  );
};

export default InputField;
